export const SmsProviderConstants = {
  FETCH_SMS_PROVIDER_REQUEST: "FETCH_SMS_PROVIDER_REQUEST",
  FETCH_SMS_PROVIDER_SUCCESS: "FETCH_SMS_PROVIDER_SUCCESS",
  FETCH_SMS_PROVIDER_FAILURE: "FETCH_SMS_PROVIDER_FAILURE",
  ADD_SMS_PROVIDER_REQUEST: "ADD_SMS_PROVIDER_REQUEST",
  ADD_SMS_PROVIDER_SUCCESS: "ADD_SMS_PROVIDER_SUCCESS",
  ADD_SMS_PROVIDER_FAILURE: "ADD_SMS_PROVIDER_FAILURE",
  SMS_PROVIDER_SEARCH_REQUEST: "SMS_PROVIDER_SEARCH_REQUEST",
  SMS_PROVIDER_SEARCH_SUCCESS: "SMS_PROVIDER_SEARCH_SUCCESS",
  SMS_PROVIDER_SEARCH_FAILURE: "SMS_PROVIDER_SEARCH_FAILURE",
  SMS_PROVIDER_AUTO_SEARCH_REQUEST: "SMS_PROVIDER_AUTO_SEARCH_REQUEST",
  SMS_PROVIDER_AUTO_SEARCH_SUCCESS: "SMS_PROVIDER_AUTO_SEARCH_SUCCESS",
  SMS_PROVIDER_AUTO_SEARCH_FAILURE: "SMS_PROVIDER_AUTO_SEARCH_FAILURE",
  GET_SMS_PROVIDER_REQUEST: "GET_SMS_PROVIDER_REQUEST",
  GET_SMS_PROVIDER_SUCCESS: "GET_SMS_PROVIDER_SUCCESS",
  GET_SMS_PROVIDER_FAILURE: "GET_SMS_PROVIDER_FAILURE",
  UPDATE_SMS_PROVIDER_REQUEST: "UPDATE_SMS_PROVIDER_REQUEST",
  UPDATE_SMS_PROVIDER_SUCCESS: "UPDATE_SMS_PROVIDER_SUCCESS",
  UPDATE_SMS_PROVIDER_FAILURE: "UPDATE_SMS_PROVIDER_FAILURE",
  DOWNLOAD_SMS_PROVIDER_REQUEST: "DOWNLOAD_SMS_PROVIDER_REQUEST",
  DOWNLOAD_SMS_PROVIDER_SUCCESS: "DOWNLOAD_SMS_PROVIDER_SUCCESS",
  DOWNLOAD_SMS_PROVIDER_FAILURE: "DOWNLOAD_SMS_PROVIDER_FAILURE",
  UPLOAD_SMS_PROVIDER_REQUEST: "UPLOAD_SMS_PROVIDER_REQUEST",
  UPLOAD_SMS_PROVIDER_SUCCESS: "UPLOAD_SMS_PROVIDER_SUCCESS",
  UPLOAD_SMS_PROVIDER_FAILURE: "UPLOAD_SMS_PROVIDER_FAILURE",
};
